import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

class ScrollToTop extends Component {
  constructor(props) {
    super(props);
    this.contaienrRef = React.createRef(null);
  }

  componentDidMount() {
    // 防止chrome刷新后无法定位到顶部
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      if (!this.contaienrRef.current) {
        this.contaienrRef.current = document.documentElement || document.body;
      }
      // 报错导致整个组件树卸载查询不到dom而引起错误
      // 如果滚动被接管了，就不执行
      if (this.contaienrRef.current && !this.props.takeOverscroll) {
        this.contaienrRef.current.scrollTop = 0;
      }
    }
  }

  render() {
    return this.props.children;
  }
}

const _ScrollToTop = connect((state) => {
  return {
    takeOverscroll: state.isTakeOverscroll.takeOverscroll,
  };
})(ScrollToTop);

export default withRouter(_ScrollToTop);
